import { render, staticRenderFns } from "./RegUnimacs.vue?vue&type=template&id=b6f7fae2"
import script from "./RegUnimacs.vue?vue&type=script&lang=js"
export * from "./RegUnimacs.vue?vue&type=script&lang=js"
import style0 from "./RegUnimacs.vue?vue&type=style&index=0&id=b6f7fae2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports